























































































import { Component, Vue } from "vue-property-decorator";
import { extractPlan } from "@/req/moneyTx";
import headerTitle from "@/components/headerTitle.vue";
import txAuditModel from "./model/txAuditModel.vue";

@Component({
  components: { headerTitle, txAuditModel },
})
export default class Home extends Vue {
  public boxId: any = ""; // 盒子号
  public UId: any = ""; // uid
  public orderId: any = "";
  public txBoxId: any = "";
  public txPayId: any = "";
  public time: any = "";
  public stime: any = "";
  public etime: any = "";
  public typeLimit = 0;
  public typeList: any = [
    {
      id: 2,
      name: "交易币",
    },
    {
      id: 1,
      name: "金币",
    },
  ];
  public moneyLimit: any = "1";
  public moneyList: any = [
    {
      id: "1",
      name: "全部",
    },
    {
      id: "2",
      name: "支付宝",
    },
    {
      id: "3",
      name: "盒币",
    },
  ];
  public page = 1;
  public size = 10;
  public loading = false;
  public options = {
    disabledDate(date) {
      return date && date.valueOf() > Date.now();
    },
  };
  public columns = [
    {
      width: 100,
      title: "ID",
      key: "id",
      align: "center",
    },
    {
      width: 150,
      title: "提现时间",
      key: "apply_time",
      align: "center",
      render: (h, params) => {
        return h("span", this.$fn.toDateSymbol(params.row.apply_time));
      },
    },
    {
      title: "提现盒子号",
      key: "account",
      slot: "account",
      align: "center",
    },
    {
      title: "提现类型",
      key: "extract_type",
      align: "center",
      render: (h, params) => {
        return h("span", params.row.extract_type == 1 ? "支付宝" : "盒币");
      },
    },
    {
      title: "提现金额",
      key: "total_extract_money",
      align: "center",
    },
    {
      title: "手续费（人民币）",
      key: "extarct_charge_money",
      align: "center",
    },
    {
      title: "提现手续费抵扣劵",
      key: "use_coupon_money",
      align: "center",
    },
    {
      title: "提现支付宝账号",
      key: "alipay_account",
      align: "center",
    },
    {
      title: "提现IP",
      key: "ip",
      align: "center",
    },
    {
      title: "提现设备",
      key: "device",
      align: "center",
    },
    {
      title: "绑定手机号",
      key: "phone",
      align: "center",
    },
    // {
    //   title: "状态",
    //   key: "status",
    //   slot: "status",
    //   align: "center",
    // },
    {
      title: "审核进度",
      key: "audit_status",
      slot: "audit_status",
      align: "center",
    },
  ];
  public data: any = [];
  public addType(index) {
    this.page = 1;
    this.typeLimit = index;
    this.getList();
  }
  public addMoney(index) {
    this.page = 1;
    this.moneyLimit = index;
    this.getList();
  }
  public mounted() {
    this.getList();
  }
  public change(i) {
    this.page = i;
    this.getList();
  }
  public async getList() {
    this.loading = true;
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      type: this.typeList[this.typeLimit].id,
      extract_type:
        this.moneyLimit == "1" ? "" : this.moneyLimit == "2" ? 1 : 2,
      page: this.page,
      pagenum: this.size,
      account: this.boxId,
      uid: this.UId,
    };
    const res = await extractPlan(obj);
    if (res.code == 0) {
      this.data = res.data.list;
      this.loading = false;
    }
  }
}
